var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 1.43306C9.80214 1.18898 10.1979 1.18898 10.4419 1.43306L13.7232 4.71431C13.9673 4.95839 13.9673 5.35411 13.7232 5.59819C13.4791 5.84227 13.0834 5.84227 12.8393 5.59819L10 2.75888L7.16069 5.59819C6.91661 5.84227 6.52089 5.84227 6.27681 5.59819C6.03273 5.35411 6.03273 4.95839 6.27681 4.71431L9.55806 1.43306Z",
    fill: "#1990FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.25C10.3452 1.25 10.625 1.52982 10.625 1.875V10.625C10.625 10.9702 10.3452 11.25 10 11.25C9.65482 11.25 9.375 10.9702 9.375 10.625V1.875C9.375 1.52982 9.65482 1.25 10 1.25Z",
    fill: "#1990FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49112 7.86612C3.72554 7.6317 4.04348 7.5 4.375 7.5H6.25C6.59518 7.5 6.875 7.77982 6.875 8.125C6.875 8.47018 6.59518 8.75 6.25 8.75H4.375L4.375 16.875H15.625V8.75H13.75C13.4048 8.75 13.125 8.47018 13.125 8.125C13.125 7.77982 13.4048 7.5 13.75 7.5H15.625C15.9565 7.5 16.2745 7.6317 16.5089 7.86612C16.7433 8.10054 16.875 8.41848 16.875 8.75V16.875C16.875 17.2065 16.7433 17.5245 16.5089 17.7589C16.2745 17.9933 15.9565 18.125 15.625 18.125H4.375C4.04348 18.125 3.72554 17.9933 3.49112 17.7589C3.2567 17.5245 3.125 17.2065 3.125 16.875V8.75C3.125 8.41848 3.2567 8.10054 3.49112 7.86612Z",
    fill: "#1990FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.5b9c1e651ea7fdbf97e61e3b48e82ca6.svg";
export { ForwardRef as ReactComponent };